import { Instagram, Linkedin, Mail } from "lucide-react";
import { toast } from "sonner";
import { LOGO_DARK_SRC, BRAND_NAME, INSTAGRAM_URL, LINKEDIN_URL, CONTACT_EMAIL, isLiveUrl } from "../../config";

function SocialLink({ href, live, label, testId, children }) {
  const onClick = (e) => {
    if (!live) {
      e.preventDefault();
      toast(`${label} link not added yet`, {
        description: `Add it in src/config.js — search for ${label.toUpperCase()}_URL.`,
      });
    }
  };
  return (
    <a
      href={live ? href : "#"}
      target={live ? "_blank" : undefined}
      rel={live ? "noopener noreferrer" : undefined}
      onClick={onClick}
      aria-label={label}
      data-testid={testId}
      className="flex h-11 w-11 items-center justify-center rounded-full border-2 border-paper/40 text-paper transition-colors duration-300 hover:border-sunny hover:bg-sunny hover:text-navy"
    >
      {children}
    </a>
  );
}

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-navy pt-10 pb-8 md:pt-12" aria-label="Footer">
      <div className="mx-auto max-w-[1440px] px-5 md:px-12 lg:px-20">
        <div className="flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
          <div>
            <img src={LOGO_DARK_SRC} alt={`${BRAND_NAME} logo`} className="h-10 w-auto md:h-11" data-testid="footer-logo" />
            <p className="mt-3 font-display text-lg font-medium text-paper/75" data-testid="footer-tagline">
              It&rsquo;s more than paper.
            </p>
          </div>
          {/* SOCIAL LINKS — edit URLs in src/config.js */}
          <div className="flex items-center gap-3" data-testid="footer-socials">
            <SocialLink href={INSTAGRAM_URL} live={isLiveUrl(INSTAGRAM_URL)} label="Instagram" testId="footer-instagram">
              <Instagram className="h-5 w-5" aria-hidden="true" />
            </SocialLink>
            <SocialLink href={LINKEDIN_URL} live={isLiveUrl(LINKEDIN_URL)} label="LinkedIn" testId="footer-linkedin">
              <Linkedin className="h-5 w-5" aria-hidden="true" />
            </SocialLink>
            <SocialLink href={`mailto:${CONTACT_EMAIL}`} live label={`Email ${CONTACT_EMAIL}`} testId="footer-email">
              <Mail className="h-5 w-5" aria-hidden="true" />
            </SocialLink>
          </div>
        </div>
        <div className="mt-8 flex flex-col gap-2 border-t-2 border-paper/15 pt-5 text-sm font-bold text-paper/60 md:flex-row md:items-center md:justify-between">
          <p data-testid="footer-copyright">© 2026 {BRAND_NAME}</p>
          <p data-testid="footer-made-with">
            Made with curiosity <span className="text-blush">+</span> paper.
          </p>
        </div>
      </div>
    </footer>
  );
}
